var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAspectRatioOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_aspect_ratio_outline_svg__clip0_37861_11196)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.954 23.874V8.017c0-.823.318-1.611.886-2.193a2.988 2.988 0 012.139-.908l22.042.11c.802 0 1.572.326 2.139.907a3.14 3.14 0 01.886 2.193v15.857a3.14 3.14 0 01-.886 2.193 2.988 2.988 0 01-2.139.908l-22.042-.109a2.988 2.988 0 01-2.14-.908 3.14 3.14 0 01-.885-2.193zm2.312.731c.189.194.445.303.713.303h6.962v-8.891H4.98a.996.996 0 00-.713.302c-.19.194-.296.457-.296.731v6.824c0 .274.107.537.296.731zm9.675-8.588v8.89h4.14V17.05c0-.274-.107-.537-.296-.73a.996.996 0 00-.713-.303h-3.13zm13.08-8.925L4.979 6.983a.996.996 0 00-.713.303c-.19.194-.296.457-.296.73v6.114c.324-.12.665-.18 1.009-.18h12.093c.802 0 1.571.326 2.139.908a3.14 3.14 0 01.886 2.192v7.858l6.924.109a.996.996 0 00.713-.303c.19-.194.295-.456.295-.73V8.125c0-.274-.106-.537-.295-.731a.996.996 0 00-.713-.303z",
    fill: props.color
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_aspect_ratio_outline_svg__clip0_37861_11196"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

export default SvgIconAspectRatioOutline;